angular.module('invoice')
    .component('invoiceCostTypePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            modelType: '<?',
            activeOnly: "<?",
            onChange: "&?"
        },
        templateUrl: "app/invoice/cost-type/picker.html",
        controller: function (InvoiceCostType){
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.activeOnly = ctrl.activeOnly != null ? ctrl.activeOnly : true;

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);

                // ctrl.refreshData();
            }

            ctrl.refreshData = search => {
                let selectedId = null
                if(ctrl.modelType === "id" && ctrl.ngModelCtrl.$modelValue != null) {
                    selectedId = ctrl.ngModelCtrl.$modelValue;
                }
                else if(ctrl.modelType === "object" && ctrl.ngModelCtrl.$modelValue != null) {
                    selectedId = ctrl.ngModelCtrl.$modelValue.id;
                }

                let params = {
                    search: search,
                    size: 1000,
                    activeOnly: ctrl.activeOnly,
                    selectedId: selectedId
                };
                InvoiceCostType.autocomplete(params).$promise.then(items => {
                    this.items = items
                });
            }

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange(ctrl.selected);
                }
                // if (angular.isFunction(ctrl.onChange())) {
                //     ctrl.onChange()($item);
                // }
            };
        }
    })
